export const w8BenReminderTexts = {
	w8Warning:
		'The W-8BEN form requires recertification. If your personal information and address remain unchanged, please proceed with the recertification process. If any updates to your personal data are required, please contact your administrator.',
	w8Expires:
		'The W-8BEN form has expired. As a result, you are no longer eligible for a reduced tax rate. To restore eligibility for reduced tax rates, please initiate the W-8BEN recertification process.',
};
